// extracted by mini-css-extract-plugin
export default {"arrowRight":"updated-license-keys_arrowRight__L0Hoy"};